import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { DepartmentModel } from '../../models/DepartmentModel'


export interface DepartmentState {
    Department: DepartmentModel
    DepartmentList: DepartmentModel[]
}

const initialState: DepartmentState = {
    Department: {} as DepartmentModel,
    DepartmentList: [],
}

export const DepartmentSlice = createSlice({
    name: 'department',
    initialState,
    reducers: {
        setDepartment: (state, action: PayloadAction<DepartmentModel[]>) => {
            state.DepartmentList = action.payload
        },
        saveDepartment: (state, action: PayloadAction<DepartmentModel>) => {
            let room = action.payload
            if (room.Id > 0) {
                let defaultModel: DepartmentModel = { Id: 0, DepartmentName: room.DepartmentName }
                let currentRoom =
                    state.DepartmentList.find((c) => c.Id === room.Id) || defaultModel
                    currentRoom.DepartmentName = room.DepartmentName
            } else {
                room.Id = (Math.max(...state.DepartmentList.map((c) => c.Id)) || 0) + 1
                state.DepartmentList.push(room)
            }
        },
        getDepartmentById: (state, action: PayloadAction<number>) => {
            let id = action.payload
            let Department: DepartmentModel = {} as DepartmentModel
            if (id > 0) {
                let currentDepartment: DepartmentModel[] = state.DepartmentList
                Department = currentDepartment.find((c) => c.Id === id) || ({} as DepartmentModel)
            }

            state.Department = Department
        },
        deleteDepartment: (state, action: PayloadAction<string>) => {
            let id: string = action.payload
            let ids: number[] = id.split(',').map((i) => parseInt(i))
            if (ids && ids.length > 0) {
                let currentDepartment: DepartmentModel[] = state.DepartmentList
                state.DepartmentList = currentDepartment.filter((c) => !ids.includes(c.Id))
            }
        },
    },
})

export const { setDepartment, saveDepartment, getDepartmentById, deleteDepartment } =
DepartmentSlice.actions

export default DepartmentSlice.reducer
